import axios from 'axios'
const URL_API_PAIS = process.env.VUE_APP_URL_API_PAIS

export class PaisApiService {
  /**
   * Devuelve todos los paises
   * @return Pais[]
   */
  getAllPais () {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = URL_API_PAIS + 'getAllPais'
    return axios
      .get(url, config)
      .then(function (response) {
        return response.data
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}
